import question from '@/api/eschool/e-exam/question'
import mainProgram from '@/api/main-program'
import subProgram from '@/api/sub-program'
import level from '@/api/level'
import grade from '@/api/grade'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  main_programs: [],
  questionTypes: [],
  answerOptions: [],
  difficultyLevels: [],
  questionCatalogs: [],
  scoreBases: [],
  letter: [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ],
  number: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26'
  ],
  roman_number: [
    'I',
    'II',
    'III',
    'IV',
    'V',
    'VI',
    'VII',
    'VIII',
    'IX',
    'X',
    'XI',
    'XII',
    'XIII',
    'XIV',
    'XV',
    'XVI',
    'XVII',
    'XVIII',
    'XIX',
    'XX',
    'XXI',
    'XXII',
    'XXIII',
    'XXIV',
    'XXV',
    'XXVI'
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_MAIN_PROGRAM(state, value) {
    state.main_programs = value
  },
  SET_QUESTION_TYPES(state, value) {
    state.questionTypes = value
  },
  SET_ANSWER_OPTIONS(state, value) {
    state.answerOptions = value
  },
  SET_DISFFICULTY_LEVELS(state, value) {
    state.difficultyLevels = value
  },
  SET_QUESTION_CATALOGS(state, value) {
    state.questionCatalogs = value
  },
  SET_SCORE_BASES(state, value) {
    state.scoreBases = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        status: context.state.status
      },
      attrubutes
    )
    return question.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return question.store(data)
  },
  update(context, data) {
    return question.update(data)
  },
  changeStatus(context, { id, data }) {
    question.changeStatus(id, data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await question.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getMainProgram(context) {
    return mainProgram
      .get({
        params: {
          fields: {
            academic_program_mains: 'acp_id,acp_name_foreign'
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit(
          'SET_MAIN_PROGRAM',
          _.orderBy(response.data, ['apc_name_foreign'])
        )
        return Promise.resolve(response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  },
  getSubProgram(context, attributes = {}) {
    return subProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          filter: {
            acp_id: attributes.acp_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLevel(context, attributes = {}) {
    return level.get({
      params: Object.assign(
        {
          fields: {
            academic_program_levels: 'level_id,level_name_foreign'
          },
          filter: {
            acps_id: attributes.acps_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGrade(context, attributes = {}) {
    return grade.get({
      params: Object.assign(
        {
          fields: {
            academic_program_level_grades: 'grade_id,grade_name_foreign'
          },
          filter: {
            level_id: attributes.level_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  async getQuestionType(context) {
    if (!context.state.questionTypes.length > 0) {
      let response = await question.getQuestionType()
      context.commit(
        'SET_QUESTION_TYPES',
        _.orderBy(response, ['question_type_id'])
      )
    }
  },
  async getAnswerOption(context) {
    if (!context.state.answerOptions.length > 0) {
      let response = await question.getAnswerOption()
      context.commit(
        'SET_ANSWER_OPTIONS',
        _.orderBy(response, ['answer_option_id'])
      )
    }
  },
  async getDifficultyLevel(context) {
    if (!context.state.difficultyLevels.length > 0) {
      let response = await question.getDifficultyLevel()
      context.commit(
        'SET_DISFFICULTY_LEVELS',
        _.orderBy(response, ['difficulty_level_id'])
      )
    }
  },
  async getQuestionCatalog(context) {
    if (!context.state.questionCatalogs.length > 0) {
      let response = await question.getQuestionCatalog()
      context.commit(
        'SET_QUESTION_CATALOGS',
        _.orderBy(response, ['question_catalog_id'])
      )
    }
  },
  async getScoreBase(context) {
    if (!context.state.scoreBases.length > 0) {
      let response = await question.getScoreBase()
      context.commit('SET_SCORE_BASES', _.orderBy(response, ['sc_base_id']))
    }
  }
}
